import {createSlice} from '@reduxjs/toolkit'

interface initialInterface {
  // show: any,
  response: any
}

const initialState: initialInterface = {
  // show: false,
  response: {},
}

const ResponseModalSlice = createSlice({
  name: 'ResponseModal',
  initialState,
  reducers: {
    setResponse: (state, action) => {
      // state.show = true;
      state.response = action.payload.response
    },
  },
})

export const {setResponse} = ResponseModalSlice.actions
export default ResponseModalSlice.reducer
